<template>
  <div>
    <el-upload
      class="avatar-uploader2"
      :show-file-list="false"
      :auto-upload="false"
      accept="video/mp4"
      :disabled="disabled || hasFile || isUploading"
      :on-change="onFileChange"
      action="#">
      <el-button size="mini" type="primary" :disabled="disabled || hasFile || isUploading">上传视频</el-button>
      <span style="margin-left:8px;color:#666" v-show="showProgress">{{ file && file.name }} ({{ file && formatSize(file.size) }})</span>
    </el-upload>

    <div style="margin-top:10px;">
      <div class="progress-container" v-show="showProgress">
        <div class="progress-bar" :style="{width: progress + '%'}"></div>
        <div class="progress-cancel" @click.stop="cancelUploadAndClear" title="取消上传并清空">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div style="margin-top:6px;" v-show="showProgress">{{ progress.toFixed(1) }}%</div>
      <div class="button-group">
        <el-button size="mini" type="danger" @click="pauseUpload" v-show="isUploading && !isPaused">暂停上传</el-button>
        <el-button size="mini" type="primary" @click="resumeUpload" v-show="isPaused">继续上传</el-button>
      </div>
    </div>
    <!-- 文件列表显示（优先父级fileListHt，否则展示本地fileList） -->
    <div v-if="displayList.length > 0" class="file-list" style="margin-top: 8px;">
      <div v-for="(file, index) in displayList" :key="index" class="file-item">
        <span class="file-name" @click="previewVideo(file)" :title="'点击查看视频'" style="cursor: pointer; color: #409EFF;">{{ file.name || file.fileName }}</span>
        <span class="file-size" v-if="file.size">({{ formatSize(file.size) }})</span>
        <el-button 
          size="mini" 
          type="danger" 
          icon="el-icon-delete" 
          @click="handleRemove(file, index)"
          :disabled="disabled"
          style="margin-left: 8px;">
          删除
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'BoyoUploadFour',
  props: {
    value: String,
    disabled: Boolean,
    // 可选：覆盖默认层级与类名，以便最小侵入式适配页面复杂层级
    action: String,
    src: String,
    fileListHt: {
      type: Array,
      default: () => []
    },

  },
  data () {
    return {
      // 上传状态
      isPaused: false,
      isUploading: false,
      currentCancel: null,
      lastStart: 0,
      taskId: null,
      file: null,
      fileMd5: null,
      chunkSize: 1024 * 1024 * 5,
      progress: 0,
      fileList: []

    }
  },

  watch: {
    fileListHt (val) {
      // 父级变更时同步内部展示
      this.fileList = val || []
    },

  },
  computed: {
    displayList () {
      // 统一以内部列表作为展示源；父级变化通过 watch 同步进来
      return this.fileList || []
    },
    hasFile () {
      // 超过或等于3个则禁用继续选择
      return (this.fileList && this.fileList.length >= 3)
    },
    showProgress () {
      // 仅在有选中文件且未完成时显示进度
      return !!this.file && this.progress > 0 && this.progress < 100
    }
  },
  methods: {
    ensureCrypto () {
      return new Promise((resolve) => {
        if (window.CryptoJS) return resolve(true)
        const s = document.createElement('script')
        s.src = 'https://cdn.bootcdn.net/ajax/libs/crypto-js/4.2.0/crypto-js.min.js'
        s.onload = () => resolve(true)
        s.onerror = () => resolve(false)
        document.head.appendChild(s)
      })
    },
    onFileChange (fileObj) {
      // element 上传 change 回调 fileObj.raw 为原生 File
      this.file = fileObj && fileObj.raw ? fileObj.raw : null
      this.progress = 0
      this.resetState(false)
      // 选择后自动开始上传
      this.$nextTick(() => {
        this.checkUpload()
      })
    },
    formatSize (bytes) {
      if (bytes < 1024) return bytes + 'B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'KB'
      if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + 'MB'
      return (bytes / 1024 / 1024 / 1024).toFixed(1) + 'GB'
    },
    // 入口：校验并开始/续传
    async checkUpload () {
      if (!this.file || this.isUploading || this.isPaused) return
      this.isUploading = true
      // 简易 md5（与示例一致）：name+size+lastModified，再取 md5
      const haveCrypto = await this.ensureCrypto()
      const raw = this.file.name + this.file.size + this.file.lastModified
      this.fileMd5 = haveCrypto && window.CryptoJS ? window.CryptoJS.MD5(raw).toString() : raw
      this.$api.File.checkMd5({ md5: this.fileMd5 }).then(res => {
        if (!res || res.code !== 0) {
          this.$message.error('校验失败: ' + ((res && res.msg) ? res.msg : '未知错误'))
          this.resetState()
          return
        }
        const start = Number(res && res.data && res.data.fileSize ? res.data.fileSize : 0) || 0
        const taskId = res && res.data ? res.data.taskId : null
        this.lastStart = start
        this.taskId = taskId
        if (start > 0) {
          const percent = (start / this.file.size * 100).toFixed(1)
          this.progress = Number(percent)
        }
        // 小文件优化：若文件不超过一个分片且没有已传进度，则整体上传
        if (this.file.size <= this.chunkSize && start === 0) {
          this.uploadWholeFile()
        } else {
          this.upload(start)
        }
      }).catch(() => {
        this.$message.error('校验请求失败')
        this.resetState()
      })
    },
    // 小文件整体上传（不切割分片，兼容后端分片参数）
    uploadWholeFile () {
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('fileName', this.file.name)
      formData.append('fileSize', 0)
      formData.append('taskId', this.taskId)
      formData.append('chunkNumber', 1)
      formData.append('chunkSize', this.file.size)
      formData.append('totalChunks', 1)
      formData.append('fileTotalSize', this.file.size)
      formData.append('fileMd5', this.fileMd5)

      const source = axios.CancelToken.source()
      this.currentCancel = source
      this.$api.File.chunkUpload(formData, {
        onUploadProgress: (e) => {
          if (e.total) {
            const percent = (e.loaded / this.file.size * 100)
            this.progress = percent > 100 ? 100 : percent
          }
        },
        cancelToken: source.token
      }).then(res => {
        if (!res || res.code !== 0) {
          this.$message.error('文件上传失败: ' + ((res && res.msg) ? res.msg : '未知错误'))
          this.resetState()
          return
        }
        this.progress = 100
        const uploadedPath = res.data.pathFile
        
        // 创建文件对象并添加到文件列表（最多3个，避免重复）
        const fileObj = {
          name: this.file.name,
          size: this.file.size,
          type: this.file.type,
          url: uploadedPath,
          fileName: uploadedPath
        }
        let newList = [...(this.fileList || [])]
        if (newList.length >= 3) {
          this.$message.warning('最多上传3个视频')
          this.resetState(false)
          return
        }
        if (!newList.some(f => f.fileName === uploadedPath)) {
          newList.push(fileObj)
        }
        this.fileList = newList
        // 若父组件未管理 fileListHt，则本地展示即可；
        // 同时向父级上抛成功事件，父级可据此写入 formInfo.data[item.value]
        // 触发成功事件
        this.$emit('on-success', { code: 0, msg: '成功', data: uploadedPath }, fileObj, this.fileList, this.value)
        this.resetState(false)
      }).catch(err => {
        if (axios.isCancel && axios.isCancel(err)) return
        this.$message.error('文件上传失败')
        this.resetState()
      })
    },
    // 分片上传（可被递归调用）
    upload (start) {
      if (this.isPaused) return
      const totalSize = this.file.size
      const end = Math.min(start + this.chunkSize, totalSize)
      const currChunk = Math.floor(start / this.chunkSize) + 1
      const totalChunks = Math.ceil(totalSize / this.chunkSize)
      const chunkFile = this.file.slice(start, end)
      if (!chunkFile) {
        this.$message.error('分片切割失败')
        this.resetState()
        return
      }
      const formData = new FormData()
      formData.append('file', chunkFile)
      formData.append('fileName', this.file.name)
      formData.append('fileSize', start)
      formData.append('taskId', this.taskId)
      formData.append('chunkNumber', currChunk)
      formData.append('chunkSize', this.chunkSize)
      formData.append('totalChunks', totalChunks)
      formData.append('fileTotalSize', totalSize)
      formData.append('fileMd5', this.fileMd5)

      const source = axios.CancelToken.source()
      this.currentCancel = source
      this.$api.File.chunkUpload(formData, {
        onUploadProgress: (e) => {
          if (e.total) {
            const percent = ((start + e.loaded) / totalSize * 100)
            this.progress = percent > 100 ? 100 : percent
          }
        },
        cancelToken: source.token
      }).then(res => {
        if (!res || res.code !== 0) {
          this.$message.error('分片' + currChunk + '上传失败: ' + ((res && res.msg) ? res.msg : '未知错误'))
          this.resetState()
          return
        }
        if ((res && res.data && res.data.result === '上传完毕') || end >= totalSize) {
          this.progress = 100
          const uploadedPath = res.data.pathFile
          
          // 创建文件对象并添加到文件列表（最多3个，避免重复）
          const fileObj = {
            name: this.file.name,
            size: this.file.size,
            type: this.file.type,
            url: uploadedPath,
            fileName: uploadedPath
          }
          let newList = [...(this.fileList || [])]
          if (newList.length >= 3) {
            this.$message.warning('最多上传3个视频')
            this.resetState(false)
            return
          }
          if (!newList.some(f => f.fileName === uploadedPath)) {
            newList.push(fileObj)
          }
          this.fileList = newList
          // 触发成功事件
          this.$emit('on-success', { code: 0, msg: '成功', data: uploadedPath }, fileObj, this.fileList, this.value)
          this.resetState(false)
        } else {
          this.lastStart = end
          this.upload(end)
        }
      }).catch(err => {
        if (axios.isCancel && axios.isCancel(err)) {
          // 主动取消，不提示错误
          return
        }
        this.$message.error('分片' + currChunk + '上传失败')
        this.resetState()
      })
    },
    cancelUploadAndClear () {
      try {
        if (this.currentCancel) {
          this.currentCancel.cancel('用户取消上传')
          this.currentCancel = null
        }
      } catch (e) {}
      // 清空并通知父组件
      this.clearComponent()
      this.$message.info('已取消上传')
    },
    pauseUpload () {
      if (!this.isUploading || this.isPaused) return
      if (this.currentCancel) {
        // 使用自定义的取消原因，避免被当作错误处理
        this.currentCancel.cancel('用户主动暂停上传')
        this.currentCancel = null
      }
      this.isPaused = true
      this.isUploading = false
      this.$message.warning('上传已暂停，可点击继续上传按钮恢复')
    },
    resumeUpload () {
      if (!this.isPaused || !this.file) return
      this.isPaused = false
      this.isUploading = true
      this.upload(this.lastStart)
    },
    resetState (resetProgress = true) {
      this.isPaused = false
      this.isUploading = false
      this.currentCancel = null
      if (resetProgress) this.progress = 0
    },
    // 清空组件所有状态（供父组件调用）
    clearComponent () {
      // 取消正在进行的上传
      if (this.currentCancel) {
        try {
          this.currentCancel.cancel('组件重置，取消上传')
        } catch (e) {
          console.warn('取消上传时出错:', e)
        }
        this.currentCancel = null
      }
      
      // 重置所有状态
      this.isPaused = false
      this.isUploading = false
      this.progress = 0
      this.lastStart = 0
      this.taskId = null
      this.file = null
      this.fileMd5 = null
      this.currentVideoUrl = ''
      
      // 清空文件列表
      this.fileList = []
      
      // 触发清空事件，通知父组件
      this.$emit('on-clear', this.value)
    },
    // 删除文件
    handleRemove (file, index) {
      this.$confirm('确定要删除这个文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 从内部列表移除
        const newFileList = [...(this.fileList || [])]
        newFileList.splice(index, 1)
        this.fileList = newFileList
        // 向父级同步通知
        this.$emit('on-remove', file, newFileList, this.value)
        this.$message.success('文件删除成功')
      }).catch(() => {
        // 用户取消删除
      })
    },
    // 预览视频
    previewVideo (file) {
      if (!file || (!file.url && !file.fileName)) {
        this.$message.warning('视频文件路径不存在')
        return
      }
      this.$emit('on-dialog', file.url || file.fileName)
    }
  },
  // 组件销毁前清理资源
  beforeDestroy () {
    this.clearComponent()
  }
}
</script>

<style scoped lang="stylus">
.progress-container
  width 100%
  height 12px
  border 1px solid #e5e5e5
  margin 6px 0
  border-radius 6px
  overflow hidden
  position relative
.progress-bar
  height 100%
  background-color #4CAF50
  width 0%
  transition width .2s ease
.progress-cancel
  position absolute
  right 6px
  top 50%
  transform translateY(-50%)
  width 22px
  height 22px
  border-radius 50%
  background rgba(0, 0, 0, .35)
  border none
  display flex
  align-items center
  justify-content center
  cursor pointer
  color #fff
  transition all .15s ease
  z-index 1
  i
    font-size 12px
    line-height 1
  &:hover
    background rgba(0, 0, 0, .55)
    box-shadow 0 0 6px rgba(0, 0, 0, .25)
.button-group
  margin-top 8px
.avatar-uploader>>> .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader>>> .el-upload:hover
  border-color #409EFF
.avatar-uploader2
  cursor pointer
.file-list
  border 1px solid rgba(229, 229, 229, 0.6)
  border-radius 3px
  padding 6px
  background-color rgba(250, 250, 250, 0.5)
  margin-top 6px
.file-item
  display flex
  align-items center
  padding 2px 0
  border-bottom 1px solid rgba(240, 240, 240, 0.6)
  &:last-child
    border-bottom none
.file-name
  font-weight 400
  color rgba(51, 51, 51, 0.8)
  flex 1
  font-size 12px
.file-size
  color rgba(102, 102, 102, 0.7)
  margin-left 4px
  font-size 11px
.video-preview-container
  text-align center
  padding 20px
.no-video
  padding 40px
  color #909399
</style>





// WEBPACK FOOTER //
// src/components/BoyoUploadFour/index.vue